// @flow
import { Component } from 'react';
import errorUtil from 'app/common/lib/errorUtil';
import Facebook from 'app/common/lib/Facebook';
import FbUtil from 'app/common/lib/FbUtil';
import i18n from 'app/common/lib/i18n';

export default class FacebookInit extends Component<{
  onError?: () => void,
}> {
  componentDidMount() {
    // $FlowFixMe Flow v0.104.0 upgrade supression.
    Facebook.ensureInit((_fb) => {
      const match = FbUtil.fbConnectedAccountMatchesLoggedInAccount(_fb, null);
      if (!match) {
        errorUtil.showError(
          i18n._(
            "Oops! Your account is linked to a different Facebook account than the one you're logged into now.",
          ),
        );
        if (this.props.onError) {
          this.props.onError();
        }
      }
    });
  }

  render() {
    return null;
  }
}
